.tabs {
  display: flex;
  min-height: 48px;
  overflow: auto;
  scrollbar-width: none;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 8px;
  padding: 12px 16px;
  min-height: 48px;
  min-width: 90px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-button-fontSize);
  font-weight: var(--tuna-typography-button-fontWeight);
  letter-spacing: var(--tuna-typography-button-letterSpacing);
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  border: none;
  background: none;
  color: var(--tuna-palette-text-secondary);
  border-bottom: 2px solid transparent;
  transition:
    color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    border-color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut);
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.tab:hover {
  color: var(--tuna-palette-text-primary);
}

.tab:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.tab[data-selected],
.tab[aria-selected='true'] {
  color: var(--tuna-palette-primary-main);
  border-bottom-color: var(--tuna-palette-primary-main);
}

.tab[data-disabled],
.tab:disabled {
  color: var(--tuna-palette-action-disabled);
  pointer-events: none;
}

.vertical {
  flex-direction: column;
  min-height: auto;
}

.vertical .tab {
  border-bottom: none;
  border-right: 2px solid transparent;
  justify-content: flex-start;
}

.vertical .tab[data-selected],
.vertical .tab[aria-selected='true'] {
  border-right-color: var(--tuna-palette-primary-main);
}

.container {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.containerVertical {
  flex-direction: column;
}

.scrollBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: var(--tuna-shape-radius-circle);
  background: transparent;
  color: var(--tuna-palette-text-secondary);
  cursor: pointer;
  font-size: var(--tuna-typography-fontSize-xs);
  transition:
    background var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut);
}

.scrollBtn:hover {
  background: var(--tuna-palette-action-hover);
  color: var(--tuna-palette-text-primary);
}

.scrollBtn:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.scrollBtn:disabled {
  color: var(--tuna-palette-action-disabled);
  pointer-events: none;
}

.scrollBtnHidden {
  visibility: hidden;
  pointer-events: none;
}
